module.exports = __webpack_public_path__ + "static/media/sopt21ru.5b489cac.pdf";